
import { Vue, Component, Prop } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { userLogList, userLogCount } from '@/api/agentcenter'
import { UserModule } from '@/store/modules/user'
@Component({
  name: 'updatelog',
  components: {
    SimpleTable
  }
})
export default class Updatelog extends Vue {
  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'field',
    label: '字段'
  },
  {
    prop: 'oldValue',
    label: '原值',
    format: 'trim'
  },
  {
    prop: 'freshValue',
    label: '新值',
    format: 'trim'
  },
  {
    prop: 'createName',
    label: '操作人员'
  },
  {
    prop: 'createTime',
    label: '更新时间',
    format: 'date'
  }]

  private dialogVisible = !1

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  beforeMount () {
    this.initData()
  }

  @Prop({ type: Object })
  private params!: object|any

  private async initData (pagination: any = null) {
    await userLogList({
      ...pagination || this.pagination,
      userId: this.params.id
    }).then(async (res: any) => {
      if (res.code === 10000) {
        await userLogCount({
          ...pagination || this.pagination,
          userId: this.params.id
        }).then((resCnt: any) => {
          if (res.code === 10000) {
            this.tableData.list = res.object.list
            this.tableData.totalCount = resCnt.object.totalCount
          }
        })
      }
    })
  }
}
